var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M13 3H3v10h10v8H3v46h46V57h8v10h10V57H57v-8h10V3H21v10h-8V3Zm8 18h-8v12h8V21Zm0 0h12v-8H21v8Zm28 28V37h8v12h-8Zm0 0v8H37v-8h12Z",
    clipRule: "evenodd"
  })));
};
export default SvgArea;